// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3oyu4","signatureButtonsRight":"ModalSign_signatureButtonsRight__1xhBk"};